const isSafeIntegerReal = (value) => {
  if (Number.isSafeInteger(value)) {
    return true;
  }
  if ((typeof value === 'string' || value instanceof String) && String(Number.parseInt(value, 10)) === value) {
    return true;
  }

  return false;
};

const shouldInputBeReadonly = ($handle) => $handle.is(':checked');

const isValueConsistentWithParent = ($handle, $input) => {
  const parentDictionaryValue = $handle.data('parentDictionaryValue');
  if (isSafeIntegerReal(parentDictionaryValue) && $input.val() === '') {
    return true;
  }
  if (isSafeIntegerReal(parentDictionaryValue) && Number.parseInt($input.val(), 10) === Number.parseInt(parentDictionaryValue, 10)) {
    return true;
  }

  return false;
};

const isEffectiveValueNegative = ($handle, $input) => {
  const value = $input.val();
  if (isSafeIntegerReal(value) && Number.parseInt(value, 10) < 0) {
    return true;
  }
  const parentDictionaryValue = $handle.data('parentDictionaryValue');
  if (isValueConsistentWithParent($handle, $input) && Number.parseInt(parentDictionaryValue, 10) < 0) {
    return true;
  }

  return false;
};

const handleValueUpdate = ($handle, $input, updateInputValue = false) => {
  if (shouldInputBeReadonly($handle, $input)) {
    if (updateInputValue) {
      $input.val(-1);
    }
    $input.prop('readonly', true);
    $input.addClass('disabled').addClass('ui').addClass('input');
  } else {
    if (updateInputValue) {
      $input.val('');
    }
    $input.prop('readonly', false);
    $input.removeClass('disabled');
  }

  if (isValueConsistentWithParent($handle, $input)) {
    $handle.parent().addClass('disabled');
  } else {
    $handle.parent().removeClass('disabled');
  }
};

$.fn.extend({
  initPackingFugue() {
    $('.disableFugueHandle').toArray().forEach((item) => {
      const $item = $(item);
      const $input = $item.closest('.field').find('input[type="number"]');
      if (isEffectiveValueNegative($item, $input)) {
        $item.prop('checked', true);
      }

      handleValueUpdate($item, $input);

      $input.on('change', () => {
        handleValueUpdate($item, $input);
      });
    });

    $('.disableFugueHandle').toArray().forEach((item) => {
      const $item = $(item);
      const $input = $item.closest('.field').find('input[type="number"]');

      $item.on('change', () => {
        handleValueUpdate($item, $input, true);
      });
    });
  },
});

